import { makeStyles, mergeClasses } from '@griffel/react';

import type { GriffelClassNames } from '../../../../util/classNames';
import { tokens } from '../../../../util/theme/fluent9';

const useClasses = makeStyles({
  leftNavContainer: {
    borderRight: `1px solid ${tokens.colorNeutralStroke3}`,
    backgroundColor: tokens.colorNeutralBackground2,
    zIndex: 2,
  },
  leftNavContainerAnimated: {
    transitionProperty: 'width',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
  },
});

export const useClassNames = (isAnimated: boolean): GriffelClassNames<'leftNavContainer'> => {
  const classes = useClasses();

  return {
    leftNavContainer: mergeClasses(classes.leftNavContainer, isAnimated && classes.leftNavContainerAnimated),
  };
};
